import { render, staticRenderFns } from "./event-hero.vue?vue&type=template&id=2ed9b7a0&"
import script from "./event-hero.vue?vue&type=script&lang=js&"
export * from "./event-hero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports